import { render, staticRenderFns } from "./EditVhostDialog.vue?vue&type=template&id=306beff2&"
import script from "./EditVhostDialog.vue?vue&type=script&lang=ts&"
export * from "./EditVhostDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports